import { Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./Component/Pages/Home";
import About from "./Component/Pages/About";
import Contact from "./Component/Pages/Contact";
import Project from "./Component/Pages/Project";
import Blog from "./Component/Pages/Blog";
import Register from "./Component/Pages/Register";
import Login from "./Component/Pages/Login";
import UserDashBoard from "./Component/Pages/user/UserDashBoard";
import UpdateProfile from "./Component/Pages/user/updateProfile";

import SingleBlogPage from "./Component/Pages/SingleBlog";
import PrivateRoute from "./Component/components/Routes/PrivateRoute";
import AdminDashBoard from "./Component/Pages/Admin/AdminDashBoard";
import AdminRoute from "./Component/components/Routes/AdminRoute";
import CreateBlog from "./Component/Pages/Admin/CreateBlog";
import UpdateBlog from "./Component/Pages/Admin/UpdateBlog";
import DeleteBlog from "./Component/Pages/Admin/DeleteBlog";
import CreateProject from "./Component/Pages/Admin/CreateProject";
import UpdateProject from "./Component/Pages/Admin/UpdateProject";
import DeleteProject from "./Component/Pages/Admin/DeleteProject";
import CreateClient from "./Component/Pages/Admin/CreateClient";
import UpdateClient from "./Component/Pages/Admin/UpdateClient";
import DeleteClient from "./Component/Pages/Admin/DeleteClient";
import ResumeBuilder from "./Component/Pages/ResumeBuilder";
import ForgotPassword from "./Component/Pages/ForgotPassword";
import ResetPassword from "./Component/Pages/RestPassword.jsx";

function App() {
  return (
    <div className="App">
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/project" element={<Project />} />
        {/* More specific route first */}
        <Route path="/services" element={<ResumeBuilder />} />
        <Route path="/blog/:id" element={<SingleBlogPage />} />
        {/* General route for blog listing */}
        <Route path="/blog" element={<Blog />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        {/* Protected Routes */}
        <Route element={<PrivateRoute />}>
          <Route path="/dashboard/user" element={<UserDashBoard />} />
          <Route path="/dashboard/user/profile" element={<UpdateProfile />} />
        </Route>

        {/* Admin Routes */}
        <Route element={<AdminRoute />}>
          <Route path="/dashboard/admin" element={<AdminDashBoard />} />
          <Route path="/dashboard/admin/create-blog" element={<CreateBlog />} />
          <Route
            path="/dashboard/admin/update-blog/:id"
            element={<UpdateBlog />}
          />
          <Route
            path="/dashboard/admin/delete-blog/:id"
            element={<DeleteBlog />}
          />
          <Route
            path="/dashboard/admin/create-project"
            element={<CreateProject />}
          />
          <Route
            path="/dashboard/admin/update-project"
            element={<UpdateProject />}
          />
          <Route
            path="/dashboard/admin/delete-project"
            element={<DeleteProject />}
          />
          <Route
            path="/dashboard/admin/create-client"
            element={<CreateClient />}
          />
          <Route
            path="/dashboard/admin/update-client"
            element={<UpdateClient />}
          />
          <Route
            path="/dashboard/admin/delete-client"
            element={<DeleteClient />}
          />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
